import { useState } from "react";
import { JournalistService } from "@root/services/journalist";
import { useOrganizationBranding } from "@root/context/organization-branding-context";

export function useJournalist() {
  const { slug } = useOrganizationBranding();
  const journalistService = new JournalistService();
  const [journalists, setJournalists] = useState([]);
  const [departmentsData, setDepartmentsData] = useState<any>({ rows: [], count: 0 });
  const [departmentsPage, setDepartmentsPage] = useState(1);
  const [departmentsTotalCount, setDepartmentsTotalCount] = useState(0);
  const [departmentsLoading, setDepartmentsLoading] = useState(false);
  const [lastDeptPayload, setLastDeptPayload] = useState<any>(null);
  const [journalistsData, setJournalistsData] = useState([]);
  const [topCourses, setTopCourses] = useState();
  const [subscriberStats, setSubscriberStats] = useState();
  const [loader, setLoader] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [aLlJournalistsData, setALlJournalistsData] = useState([]);
  const [aLlJournalistsLoading, setALlJournalistsLoading] = useState(false);

  const fetchJournalists = async (payload: any, showLoader: boolean = true) => {
    if (showLoader) {
      setLoader(true);
    }
    try {
      const response = await journalistService.fetchJournalistRequests({
        ...(slug && { slug }),
        ...payload,
      });

      setJournalists(response?.data?.data || []);
      setPageCount(response?.data?.data?.count);
    } finally {
      if (showLoader) {
        setLoader(false);
      }
    }
  };

  const getJournalists = async () => {
    setLoader(true);
    try {
      const response = await journalistService.fetchJournalistRequests({
        ...(slug && { slug }),
      });
      setJournalistsData(response?.data?.data || []);
    } finally {
      setLoader(false);
    }
  };

  const updateJournalistStatus = async (
    id: string | number,
    status: number,
    payload: any
  ) => {
    try {
      await journalistService.updateJournalistStatus(id, status);
      await fetchJournalists(payload, false);
    } catch (error) {
      throw error;
    }
  };

  const deleteJournalist = async (id: string | number, payload: any) => {
    try {
      await journalistService.deleteJournalist(id);
      await fetchJournalists(payload, false);
    } catch (error) {
      throw error;
    }
  };
  const deleteJournalistManagement = async (
    id: string | number,
    payload: any
  ) => {
    setALlJournalistsLoading(true);
    try {
      await journalistService.deleteJournalistManagement(id);
      await fetchALlJournalists(payload);
    } finally {
      setALlJournalistsLoading(false);
    }
  };
  const fetchSubscriberStats = async () => {
    setLoader(true);
    try {
      const response = await journalistService.getSubscriberStats(slug ?? "");
      setSubscriberStats(response?.data?.data); //
    } finally {
      setLoader(false);
    }
  };

  const fetchTopCourses = async () => {
    setLoader(true);
    try {
      const response = await journalistService.getTopCourses();
      setTopCourses(response?.data?.data?.rows);
      setPageCount(response?.data?.data?.count);
    } finally {
      setLoader(false);
    }
  };

  const fetchDepartments = async (payload: any) => {
    setDepartmentsLoading(true);
    setDepartmentsPage(1);
    const mergedPayload = {
      ...(slug && { slug }),
      ...payload,
      offset: 0,
      limit: 100,
    };
    setLastDeptPayload(mergedPayload);
    try {
      const response = await journalistService.fetchDepartments(mergedPayload);
      const data = response?.data?.data || { rows: [], count: 0 };
      setDepartmentsData(data);
      setDepartmentsTotalCount(data?.count || 0);
    } finally {
      setDepartmentsLoading(false);
    }
  };

  const fetchMoreDepartments = async () => {
    if (departmentsLoading) return;
    const loadedSoFar = departmentsData?.rows?.length || 0;
    if (loadedSoFar >= departmentsTotalCount) return; // no more pages

    const nextPage = departmentsPage + 1;
    setDepartmentsLoading(true);
    setDepartmentsPage(nextPage);
    try {
      const payload = { 
        ...lastDeptPayload, 
        offset: (nextPage - 1) * 100, 
        limit: 100 
      };
      const response = await journalistService.fetchDepartments(payload);
      const data = response?.data?.data || { rows: [], count: 0 };
      setDepartmentsData((prev: any) => ({
        rows: [...(prev?.rows || []), ...(data?.rows || [])],
        count: data?.count ?? prev?.count,
      }));
      setDepartmentsTotalCount(data?.count || departmentsTotalCount);
    } finally {
      setDepartmentsLoading(false);
    }
  };

  const fetchALlJournalists = async (payload: any = {}) => {
    setALlJournalistsLoading(true);
    console.log(payload);
    try {
      const response = await journalistService.AllJournalist(payload);
      setALlJournalistsData(response?.data?.data || { rows: [], count: 0 });
    } finally {
      setALlJournalistsLoading(false);
    }
  };
  return {
    fetchJournalists,
    journalists,
    loader,
    fetchTopCourses,
    topCourses,
    setLoader,
    getJournalists,
    journalistsData,
    updateJournalistStatus,
    deleteJournalist,
    fetchSubscriberStats,
    subscriberStats,
    pageNo,
    setPageNo,
    pageCount,
    setPageCount,
    fetchDepartments,
    fetchMoreDepartments,
    departmentsData,
    departmentsLoading,
    aLlJournalistsData,
    fetchALlJournalists,
    aLlJournalistsLoading,
    deleteJournalistManagement,
  };
}

export default useJournalist;
